import { BuyNow } from '@/types/BuyNow';
import { LOAD_HOME_DATA_SUCCESS } from './home';
import { LOAD_STOREFRONT_ITEMS_SUCCESS } from './storeFrontPage';
import type { BiddingInfo } from '@/types/BiddingInfo';
import type { Catalog } from '@/types/Catalog';
import type { Item } from '@/types/Item';
import type { ItemCardModel } from '@/types/ItemCardModel';
import type { Seller } from '@/types/Seller';
import type { TypedActionWithPayload } from '@/types/redux';

export const LOAD_ITEM_CARD_MODELS_FAIL = 'LOAD_ITEM_CARD_MODELS_FAIL';
export type LOAD_ITEM_CARD_MODELS_FAIL_ACTION = TypedActionWithPayload<
    typeof LOAD_ITEM_CARD_MODELS_FAIL,
    {
        error: any;
    },
    {
        itemIds: number[];
    }
>;

export const LOAD_ITEM_CARD_MODELS_REQUEST = 'LOAD_ITEM_CARD_MODELS_REQUEST';
export type LOAD_ITEM_CARD_MODELS_REQUEST_ACTION = TypedActionWithPayload<
    typeof LOAD_ITEM_CARD_MODELS_REQUEST,
    null,
    {
        itemIds: number[];
    }
>;

export const LOAD_ITEM_CARD_MODELS_SUCCESS = 'LOAD_ITEM_CARD_MODELS_SUCCESS';
export type LOAD_ITEM_CARD_MODELS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_ITEM_CARD_MODELS_SUCCESS,
    ItemCardModel[],
    {
        actionTime: number;
    }
>;

// TODO: make typed actions for these payload types and make a new type by combining those instead of doing this manually
export type LOAD_ITEM_DATA_FROM_ELSEWHERE_SUCCESS = TypedActionWithPayload<
    typeof LOAD_HOME_DATA_SUCCESS | typeof LOAD_STOREFRONT_ITEMS_SUCCESS,
    {
        biddingInfos?: BiddingInfo[];
        buyNows?: BuyNow[];
        catalogs?: Catalog[];
        items?: Item[];
        sellers?: Seller[];
    },
    {
        actionTime: number;
    }
>;
